export default __webpack_public_path__ + "static/media/020104202140102.52af09f3.png";